"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveConsent = exports.loadConsent = void 0;
const KEY = "ahti-surplus-calculator/consent";
/**
 * Consent to record the figures typed into the calculator. Asked once on
 * arrival and remembered. Declining changes nothing about how the tool works —
 * that is what keeps the consent freely given rather than a toll gate.
 */
const loadConsent = () => {
    try {
        const stored = window.localStorage.getItem(KEY);
        return stored === "granted" || stored === "denied" ? stored : "unset";
    }
    catch {
        return "unset";
    }
};
exports.loadConsent = loadConsent;
const saveConsent = (state) => {
    try {
        window.localStorage.setItem(KEY, state);
    }
    catch {
        // A viewer with site data blocked simply gets asked again next visit.
    }
};
exports.saveConsent = saveConsent;
